<template>
  <div class="">401</div>
</template>

<script setup>
import {} from 'vue'
</script>

<style lang="scss" scoped></style>
